import { LcgQuoteBacktestStatus } from "@redotech/crdb-enums/xborder-outbound/lcg-quote-backtest-status";
import { lcgQuoteBacktestRunIdFormat } from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";

const sharesOutput = z.object({
  shipping: z.number().nullable(),
  duties: z.number().nullable(),
  taxes: z.number().nullable(),
  productFees: z.number().nullable(),
  shipmentFees: z.number().nullable(),
  cartFees: z.number().nullable(),
});

const summaryOutput = z.object({
  orders: z.number(),
  orderValueMinor: z.number(),
  averageShipmentFeesMinor: z.number().nullable(),
  averageCartFeesMinor: z.number().nullable(),
  shares: sharesOutput,
});

export const lcgQuoteBacktestRunOutput = z.object({
  id: lcgQuoteBacktestRunIdFormat.schema,
  status: z.enum(LcgQuoteBacktestStatus),
  requestedCount: z.number(),
  totalCount: z.number(),
  completedCount: z.number(),
  failedCount: z.number(),
  currency: z.string(),
  error: z.string().nullable(),
  createdAt: z.date(),
  finishedAt: z.date().nullable(),
  results: z
    .object({
      overall: summaryOutput,
      byCountry: z.array(summaryOutput.extend({ countryCode: z.string() })),
      coverage: z.object({
        quoted: z.number(),
        skipped: z.number(),
        skipReasons: z.array(
          z.object({ reason: z.string(), count: z.number() }),
        ),
        merchantPaidShipping: z.number(),
        customerPaidShipping: z.number(),
        noShipping: z.number(),
      }),
    })
    .nullable(),
});

export type LcgQuoteBacktestRunOutput = z.infer<
  typeof lcgQuoteBacktestRunOutput
>;
